import * as React from 'react';
import FormField from '../../FormElements/Field';
import SubmitButton from '../../FormElements/SubmitButton';
import { useAccountantForm } from './useAccountantForm';
import { toggleModal } from '../../../Store/layoutSlice';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { Accountant } from '../../../Model/Accountant';
import { phoneRegex } from '../../Validators/phoneRegex';

export const AccountantForm = () => {
  const dispatch = useDispatch();
  const { register, reset, handleSubmit, formState } = useForm<Partial<Accountant>>();
  const { onSubmit, inProgress } = useAccountantForm(register, reset);

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormField name="accountantName" label="Könyvelő neve">
          <input
            type="text"
            id="accountantName"
            minLength={8}
            required
            className="form-control"
            {...register('name', {
              required: true,
              minLength: 8,
            })}
          />
        </FormField>
        <FormField name="accountantEmail" label="Könyvelő email címe">
          <input
            type="email"
            id="accountantEmail"
            required
            className="form-control"
            {...register('email', {
              required: true,
            })}
          />
        </FormField>
        <FormField name="accountantPhone" label="Könyvelő telefonszáma">
          <input
            type="tel"
            id="accountantPhone"
            className="form-control"
            {...register('mobile', {
              pattern: {
                value: phoneRegex.regex,
                message: phoneRegex.message,
              },
            })}
            title={phoneRegex.message}
          />
          {formState.errors.mobile?.message && <span className="text-danger">{formState.errors.mobile?.message}</span>}
        </FormField>
        <div className="modal-footer mt-lg-4 d-flex justify-content-around">
          <button
            onClick={() => dispatch(toggleModal())}
            type="button"
            className="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Mégse
          </button>
          <SubmitButton text={'Mentés'} className={'btn btn-primary'} inProgress={inProgress} disabled={inProgress} />
        </div>
      </form>
    </div>
  );
};
